import { queryOptions } from '@tanstack/react-query';
import ApiCalls, { API } from 'app/utils/apiCalls';

export default function countFilteredStudiesQueryOptions(params?: API.StudiesFilter) {
  return queryOptions({
    queryKey: params
      ? ([{ query: '/study/count' }, params] as const)
      : ([{ query: '/study/count' }] as const),
    queryFn: async ({ queryKey }) => {
      const [, studyFilter] = queryKey;
      return await ApiCalls.countStudies(studyFilter);
    },
  });
}
